export const
    SetProject: IProjectSettingsPageSetProjectActionCreator = (projectId) => {
        return {
            type: PROJECT_SETTINGS_PAGE_SET_TRIAL,
            projectId
        }
    };

export const
    PROJECT_SETTINGS_PAGE_SET_TRIAL = "PROJECT_SETTINGS_PAGE_SET_TRIAL"

/* Actions */

export interface IProjectSettingsPageSetProjectAction {
    type: "PROJECT_SETTINGS_PAGE_SET_TRIAL",
    projectId: number;
}

/* Action Creators */

export interface IProjectSettingsPageSetProjectActionCreator {
    (
        projectId: number
    ): IProjectSettingsPageSetProjectAction;
}


/* Final Export of actions */
export type ProjectSettingsPageAction =
    IProjectSettingsPageSetProjectAction;
